<template>
  <div class="h-full">
    <el-card class="h-full" :body-style="{ padding: '20px', height: '100%' }">
      <!-- search condition start -->
      <el-row>
        <el-input
          v-model="searchCondition.code"
          clearable
          size="small"
          :placeholder="$t('搜索代码')"
          class="w-200px mr-10px"
        ></el-input>
        <el-input
          v-model="searchCondition.name"
          clearable
          size="small"
          :placeholder="$t('搜索名称')"
          class="w-200px mr-10px"
        ></el-input>
        <el-button type="primary" @click="searchTableData">{{ $t('search') }}</el-button>
        <el-button :disabled="!$hasAccess('create')" type="primary" @click="handleEdit('create')">{{
          $t('create')
        }}</el-button>
      </el-row>
      <!-- search condition end -->
      <!-- table start -->
      <el-table
        :data="tableData"
        border
        height="calc(100% - 106px)"
        v-loading="tableLoading"
        class="mt-20px"
      >
        <el-table-column :label="$t('代码')" prop="code"></el-table-column>
        <el-table-column :label="$t('名称')" prop="name"></el-table-column>
        <el-table-column :label="$t('打开方式')" prop="openTypeStr"></el-table-column>
        <el-table-column :label="$t('操作类别')" prop="operationCategoryStr"></el-table-column>
        <el-table-column :label="$t('响应者')" prop="responder"></el-table-column>
        <el-table-column :label="$t('参数')" prop="parameterValues"></el-table-column>
        <el-table-column :label="$t('操作')" width="200">
          <template slot-scope="scope">
            <el-button
              :disabled="!$hasAccess('read')"
              size="mini"
              @click="handleRow(scope.row, 'read')"
              >{{ $t('view') }}</el-button
            >
            <el-button
              :disabled="!$hasAccess('update')"
              size="mini"
              @click="handleRow(scope.row, 'edit')"
              >{{ $t('edit') }}</el-button
            >
            <el-button
              :disabled="!$hasAccess('delete')"
              size="mini"
              @click="deleteRow(scope.row)"
              >{{ $t('delete') }}</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <!-- table end -->
      <!-- pagigation start -->
      <el-pagination
        class="mt-20px float-right"
        background
        @size-change="searchTableData()"
        @current-change="findTableData()"
        :current-page.sync="page.pageNo"
        :page-sizes="$pageSizeAll"
        :page-size.sync="page.pageSize"
        layout="total, sizes, prev, pager, next"
        :total="page.pageTotal"
      ></el-pagination>
    </el-card>
    <!-- pagigation end -->
    <!-- 新增、编辑业务操作 start -->
    <el-dialog :title="dialogTitle" width="800px" :visible.sync="dialogVisible" v-dialogDrag>
      <el-form
        ref="operationsManagementForm"
        :model="operationsManagementForm"
        :rules="operationsManagementRules"
        label-width="80px"
        :disabled="currentEditType === 'read'"
      >
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item :label="$t('代码')" prop="code">
              <el-input size="small" clearable v-model="operationsManagementForm.code" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('名称')" prop="name">
              <el-input size="small" clearable v-model="operationsManagementForm.name" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('打开方式')" prop="openType">
              <el-select
                size="small"
                v-model="operationsManagementForm.openType"
                filterable
                clearable
                class="w-full"
              >
                <el-option
                  v-for="item in openTypes"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('操作类别')" prop="operationCategory">
              <el-select
                size="small"
                filterable
                clearable
                v-model="operationsManagementForm.operationCategory"
                class="w-full"
              >
                <el-option
                  v-for="item in operationCategory"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$t('响应者')" prop="responder">
              <el-input size="small" clearable v-model="operationsManagementForm.responder" />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$t('参数名')" prop="param">
              <el-input size="small" v-model="operationsManagementForm.param" clearable>
                <el-button
                  slot="append"
                  class="el-icon-plus m-0px"
                  size="small"
                  type="primary"
                  @click="addParam()"
                ></el-button>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24" v-for="(item, index) in paramsLists" :key="item.id">
            <el-form-item label prop="openMethod">
              <el-input size="small" v-model="item.name" clearable>
                <el-button
                  slot="append"
                  class="el-icon-plus"
                  size="small"
                  type="primary"
                  @click="addParam(index)"
                ></el-button>
                <el-button
                  slot="append"
                  class="el-icon-delete position-relative"
                  size="small"
                  type="danger"
                  @click="deleteParam(item)"
                ></el-button>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="tc" v-if="currentEditType !== 'read'">
        <el-button
          type="primary"
          size="small"
          class="iconfont icon-save"
          @click="save()"
          :loading="saveLoading"
          :disabled="saveLoading"
          >{{ $t('save') }}</el-button
        >
        <el-button size="small" class="iconfont icon-close" @click="dialogVisible = false">{{
          $t('cancel')
        }}</el-button>
      </div>
    </el-dialog>
    <!-- 新增、编辑业务操作 end -->
  </div>
</template>
<script>
import StdBusinessOperation from '@/services/bsApi/StdBusinessOperation'

export default {
  name: 'operationsManagement',
  compontents: {},
  data() {
    return {
      paramsLists: [],
      dialogVisible: false,
      dialogTitle: '',
      tableLoading: false,
      searchCondition: {
        code: '',
        name: '',
      },
      tableData: [],
      page: {
        pageNo: 1,
        pageSize: 15,
        pageTotal: 0,
      },
      operationsManagementForm: {
        code: '',
        name: '',
        openType: '',
        operationCategory: '',
        responder: '',
        param: '',
      },
      operationsManagementRules: {
        code: [
          {
            required: 'true',
            message: this.$t('pleaseEnterCode'),
            trigger: 'blur',
          },
        ],
        name: [
          {
            required: 'true',
            message: '请输入名称',
            trigger: 'blur',
          },
        ],
        openType: [
          {
            required: 'true',
            message: '请选择打开方式',
            trigger: 'blur',
          },
        ],
        operationCategory: [
          {
            required: 'true',
            message: '请选择操作类别',
            trigger: 'blur',
          },
        ],
        responder: [
          {
            required: 'true',
            message: '请输入响应者',
            trigger: 'blur',
          },
        ],
        param: [
          {
            required: 'true',
            message: '请输入参数名',
            trigger: 'blur',
          },
        ],
      },
      openTypes: [],
      operationCategory: [],
      currentEditType: 'create',
      saveLoading: false,
    }
  },
  watch: {
    dialogVisible(bol) {
      if (!bol) {
        this.operationsManagementForm = this.$options.data().operationsManagementForm
        this.paramsLists = []
      }
    },
  },
  methods: {
    deleteParam(item) {
      this.paramsLists = _.difference(this.paramsLists, [item])
    },
    async handleRow(row, type) {
      this.currentEditType = type
      this.dialogTitle = type === 'edit' ? this.$t('编辑业务操作') : this.$t('查看业务操作')
      const res = await StdBusinessOperation.find({
        id: row.id,
      })
      if (res && res.code === 0 && res.data) {
        this.operationsManagementForm = res.data
        this.dialogVisible = true
        this.$nextTick(() => {
          this.$refs.operationsManagementForm.clearValidate()
        })
        this.$set(this.operationsManagementForm, 'param', res.data.parameterList[0].name)
        if (res.data.parameterList.length > 1) {
          _.forEach(res.data.parameterList, (item) => {
            delete item.createdTime
            delete item.lastModifiedTime
          })
          this.paramsLists = _.cloneDeep(res.data.parameterList)
          this.paramsLists.shift()
        }
      }
    },
    deleteRow(row) {
      this.$confirm('是否确定要删除该条数据?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(async () => {
        const res = await StdBusinessOperation.remove({
          data: [row.id],
        })
        if (res && res.code === 0) {
          this.$message.success('删除成功')
          if (this.tableData.length === 1 && this.page.pageNo > 1) {
            this.page.pageNo -= 1
          }
          this.findTableData()
        }
      })
    },
    save() {
      this.$refs.operationsManagementForm.validate(async (valid) => {
        if (valid) {
          const reqData = _.cloneDeep(this.operationsManagementForm)
          delete reqData.param
          reqData.parameterList = [
            {
              name: this.operationsManagementForm.param,
            },
          ]
          const paramsLists = _.cloneDeep(this.paramsLists)
          let validate = true
          _.forEach(paramsLists, (item) => {
            if (!item.name) {
              validate = false
            }
            delete item.id
          })
          if (!validate) {
            this.$message.warning('请补充完参数名')
            return
          }
          reqData.parameterList = [...reqData.parameterList, ...paramsLists]
          let res
          this.saveLoading = true
          if (this.currentEditType === 'edit') {
            delete reqData.createdTime
            delete reqData.lastModifiedTime
            res = await StdBusinessOperation.update({
              model: reqData,
            })
          } else {
            res = await StdBusinessOperation.save({
              model: reqData,
            })
          }
          this.saveLoading = false
          if (res && res.code === 0) {
            const text = this.currentEditType === 'create' ? '新增' : '修改'
            this.$message.success(`${text}成功`)
            this.dialogVisible = false
            this.findTableData()
          }
        }
      })
    },
    async findOpenType() {
      // 打开方式
      const res = await StdBusinessOperation.getOpenType()
      if (res && res.code === 0 && res.data) {
        _.forIn(res.data, (key, item) => {
          this.openTypes.push({
            label: key,
            value: _.toNumber(item),
          })
        })
      }
    },
    async findOperationCategory() {
      // 操作类别
      const res = await StdBusinessOperation.getOperationCategory()
      if (res && res.code === 0 && res.data) {
        _.forIn(res.data, (key, item) => {
          this.operationCategory.push({
            label: key,
            value: _.toNumber(item),
          })
        })
      }
    },
    addParam(key = undefined) {
      if (_.isNil(key)) {
        this.paramsLists.unshift({
          name: '',
          id: new Date(),
        })
        return
      }
      this.paramsLists.splice(key + 1, 0, {
        value: '',
        id: new Date(),
      })
    },
    handleEdit(type) {
      this.currentEditType = type
      this.dialogVisible = true
      this.dialogTitle = this.$t('新增业务操作')
      this.$nextTick(() => {
        this.$refs.operationsManagementForm.clearValidate()
      })
    },
    searchTableData() {
      this.page.pageNo = 1
      this.findTableData()
    },
    async findTableData() {
      const reqData = {
        pageno: this.page.pageNo,
        pagesize: this.page.pageSize,
        code: {
          $text: this.searchCondition.code,
        },
        name: {
          $text: this.searchCondition.name,
        },
      }
      this.tableLoading = true
      const res = await StdBusinessOperation.find(reqData)
      this.tableLoading = false
      if (res && res.code === 0 && res.data) {
        this.tableData = res.data
        this.page.pageTotal = res.page.recordCount
        _.forEach(this.tableData, (item) => {
          item.state = item.state === 0 // 0 启用 1 停用
        })
      }
    },
  },
  async created() {
    this.findOpenType()
    this.findOperationCategory()
    this.searchTableData()
  },
}
</script>
<style lang="scss" scoped>

/deep/.el-input-group__append {
  padding: 0 !important;
  /deep/.el-button {
    margin: 0 !important;
    background: #46a6ff !important;
    color: #fff !important;
  }
  /deep/.el-button--danger {
    color: #ffffff !important;
    background-color: #f5222d !important;
    border-color: #f5222d !important;
  }
}
/deep/.el-input-group__append .el-button {
  margin: 0 !important;
}

</style>
